import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout_green",
  "use": "icon-logout_green-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-logout_green\"><defs><style type=\"text/css\"></style></defs><path d=\"M195.2 195.2c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8-73.6 70.4-115.2 169.6-115.2 272 0 211.2 172.8 384 384 384s384-172.8 384-384c0-108.8-44.8-211.2-124.8-281.6-12.8-12.8-12.8-32-3.2-44.8 12.8-12.8 32-12.8 44.8-3.2 92.8 83.2 144 201.6 144 329.6 0 246.4-201.6 448-448 448s-448-201.6-448-448c6.4-121.6 54.4-233.6 137.6-316.8z m316.8-131.2c19.2 0 32 12.8 32 32v384c0 19.2-12.8 32-32 32s-32-12.8-32-32v-384c0-19.2 12.8-32 32-32z\" p-id=\"9495\" fill=\"#4fb8cc\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/logout_green.svg
// module id = Ayft
// module chunks = 39